(function ($) {
    $('.js-custom-scrollbar').each(function() {
        new SimpleBar(this, { autoHide: false });
    });
})(jQuery);
